// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2P75u","col":"styles_col__1bLVd"};